import Moment from 'moment';
import * as momentRange from 'moment-range';

const moment = momentRange.extendMoment(Moment);
export default moment;
